import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, ShoppingBag, ArrowRight } from 'lucide-react';
import BrandLogo from '../common/BrandLogo';

const ThankYouScreen = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const orderNumber = location.state?.orderNumber || '';
    const [countdown, setCountdown] = useState(8);

    useEffect(() => {
        if (countdown <= 0) {
            navigate('/');
            return;
        }

        const timer = setTimeout(() => {
            setCountdown(countdown - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [countdown, navigate]);

    return (
        <div
            className="min-h-screen flex items-center justify-center px-4"
            style={{
                backgroundColor: '#f5f5f5',
                position: 'relative'
            }}
        >
            <BrandLogo delay={0.2} />

            <motion.div
                className="w-full max-w-lg rounded-2xl shadow-xl p-10 text-center"
                style={{
                    backgroundColor: '#ffffff',
                    border: '3px solid #0E8164',
                    position: 'relative',
                    zIndex: 1
                }}
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: 'easeOut' }}
            >
                <motion.div
                    className="w-24 h-24 mx-auto mb-8 flex items-center justify-center rounded-full shadow-lg"
                    style={{ backgroundColor: '#dcfce7' }}
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.6, type: 'spring' }}
                >
                    <CheckCircle className="w-16 h-16 text-green-600" />
                </motion.div>

                <motion.h1
                    className="text-3xl font-extrabold text-gray-900 mb-4"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                >
                    ¡Gracias por su compra!
                </motion.h1>
                <motion.p
                    className="text-lg text-gray-600 mb-10"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.4 }}
                >
                    Su transacción ha sido procesada con éxito.
                </motion.p>

                {orderNumber && (
                    <motion.div
                        className="rounded-xl py-6 px-4 mb-4"
                        style={{
                            backgroundColor: '#0E8164',
                            border: '3px solid #0E8164'
                        }}
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.5 }}
                    >
                        <p className="text-sm font-bold uppercase tracking-widest mb-2" style={{ color: 'rgba(255,255,255,0.8)' }}>
                            Número de pedido
                        </p>
                        <motion.p
                            className="text-6xl font-black"
                            style={{ color: '#ffffff', letterSpacing: '-0.02em' }}
                            initial={{ scale: 0.5, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ delay: 0.7, type: 'spring', stiffness: 200 }}
                        >
                            {orderNumber}
                        </motion.p>
                        <p className="text-sm mt-2" style={{ color: 'rgba(255,255,255,0.75)' }}>
                            Espere su llamado
                        </p>
                    </motion.div>
                )}

                <motion.div
                    className="rounded-xl py-6 px-4 shadow-inner"
                    style={{
                        backgroundColor: '#f5f5f5',
                        border: '2px solid #0E8164'
                    }}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.6 }}
                >
                    <div className="flex items-center justify-center gap-3 mb-3">
                        <ShoppingBag className="w-6 h-6" style={{ color: '#0E8164' }} />
                        <p className="font-medium" style={{ color: '#0E8164' }}>
                            Volviendo a la pantalla de productos en
                        </p>
                    </div>

                    <motion.p
                        key={countdown}
                        className="text-5xl font-extrabold mb-1"
                        style={{ color: '#0E8164' }}
                        initial={{ scale: 0.5, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ duration: 0.4 }}
                    >
                        {countdown}
                    </motion.p>
                    <p className="text-sm" style={{ color: '#0E8164' }}>segundos</p>
                </motion.div>

                <motion.button
                    onClick={() => navigate('/')}
                    className="mt-10 inline-flex items-center gap-2 px-6 py-3 rounded-xl font-semibold text-white shadow-lg"
                    style={{ backgroundColor: '#0E8164' }}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    <span>Volver ahora</span>
                    <ArrowRight className="w-5 h-5" />
                </motion.button>
            </motion.div>
        </div>
    );
};

export default ThankYouScreen;